import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/players",
        name: "players",
        component: () => import("@/components/players/_Players.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewPlayersUI,
            breadcrumbs: {
                icon: "players-icon",
                paths: []
            },
            title: "navbar.players"
        }
    },
    {
        path: "/players/:playerId/update",
        name: "updatePlayer",
        component: () => import("@/components/players/_PlayerForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdatePlayer,
            breadcrumbs: {
                icon: "players-icon",
                paths: [
                    ["/players", i18n.t("player.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/players/activate/:playerId",
        name: "activatePlayer",
        component: () => import("@/components/players/_PlayerActivateForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreatePlayer,
            breadcrumbs: {
                icon: "players-icon",
                paths: [
                    ["/players", i18n.t("player.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/players/screenshots",
        name: "playerScreenshots",
        component: () => import("@/components/players/_PlayerScreenshots.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewPlayersUI,
            breadcrumbs: {
                icon: "camera-icon",
                paths: []
            }
        }
    },
    {
        path: "/playerMonitors",
        name: "playerMonitors",
        component: () => import("@/components/players/_PlayerMonitors.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.GetPlayerMonitors,
            breadcrumbs: {
                icon: "players-icon",
                paths: []
            },
            title: "navbar.players"
        }
    },
    {
        path: "/playerMonitors/create",
        name: "createPlayerMonitor",
        component: () => import("@/components/players/_PlayerMonitorForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreatePlayerMonitor,
            breadcrumbs: {
                icon: "monitor-icon",
                paths: [
                    ["/playerMonitors", i18n.t("playerMonitors.title")]
                ]
            },
            title: "playerMonitors.createPlayerMonitor"
        },
        props: true
    },
    {
        path: "/playerMonitors/:playerMonitorId/update",
        name: "updatePlayerMonitor",
        component: () => import("@/components/players/_PlayerMonitorForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdatePlayerMonitor,
            breadcrumbs: {
                icon: "monitor-icon",
                paths: [
                    ["/playerMonitors", i18n.t("playerMonitors.title")]
                ]
            }
        },
        props: true
    }
];
